<script setup>
defineProps({
    as: {
        type: String,
        default: 'span',
    },
    color: {
        type: String,
    },
    animated: {
        type: Boolean,
        default: false,
    },
})
</script>

<template>
    <span
        :class="{ 'animate-animated animate-tada': animated, [`bg-${color || 'dust'}-500`]: true }"
        class="px-2 py-1 -mt-1 text-sm leading-none animate-shock text-white whitespace-nowrap rounded-lg shadow relative">
        <slot></slot>
    </span>
</template>